var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08571 11.5877H9.20488C12.2274 11.4902 14.6107 9.02018 14.6215 5.97602C14.6215 2.87768 12.0974 0.353516 8.99905 0.353516C5.90071 0.353516 3.37655 2.87768 3.37655 5.97602C3.37655 9.02018 5.74905 11.4902 8.89071 11.5877C8.95571 11.5768 9.03155 11.5768 9.08571 11.5877ZM5.00155 5.97602C5.00155 3.77685 6.79988 1.97852 8.99905 1.97852C11.1982 1.97852 12.9965 3.77685 12.9965 5.97602C12.9857 8.12102 11.3174 9.86518 9.19405 9.96268C9.05321 9.95185 8.90155 9.95185 8.84738 9.96268C6.69155 9.88685 5.00155 8.14268 5.00155 5.97602Z",
    fill: "#14477D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31159 21.8035C4.92576 22.8868 7.05992 23.4285 9.18326 23.4285C11.3066 23.4285 13.4299 22.8868 15.0549 21.8035C16.5608 20.796 17.3841 19.4202 17.3841 17.936C17.3841 16.4518 16.5499 15.0869 15.0549 14.0902C11.8266 11.9344 6.56159 11.9344 3.31159 14.0902C1.80576 15.0977 0.982422 16.4735 0.982422 17.9577C0.982422 19.4418 1.80576 20.8068 3.31159 21.8035ZM2.60742 17.9685C2.60742 17.0368 3.17076 16.1485 4.21076 15.4552C6.90826 13.6568 11.4583 13.6568 14.1558 15.4552C15.1849 16.1377 15.7591 17.026 15.7591 17.9468C15.7591 18.8785 15.1958 19.7668 14.1558 20.4602C11.4583 22.2694 6.90826 22.2694 4.21076 20.4602C3.18159 19.7777 2.60742 18.8894 2.60742 17.9685Z",
    fill: "#14477D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.c5d1f0951aca37ca25180f652f83da5b.svg";
export { ForwardRef as ReactComponent };